// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3N305","questions":"styles_questions__3i7fK","footer":"styles_footer__2dWGp"};